/**
 * Mirrors `normalize_notification_route` in the notifications repository.
 * Keep this prefix set in sync with `_NOTIFICATION_ROUTE_PREFIXES` there.
 */
const NOTIFICATION_ROUTE_PREFIXES = new Set([
  'home',
  'chat',
  'write',
  'review',
  'reporting',
  'tutorials',
  'groups',
  'actions',
  'meetings',
  'wiki',
  'docs',
  'modules',
  'dashboard',
  'profile',
  'admin',
  'data-library',
  'landing',
  'notifications',
  'files',
  'helpers',
  'search',
  'surveys',
  'permissions',
  'specialists',
  'customerio',
  'asset-reviews'
]);

/** Strip a leading tenant code so `/acme/chat/123` matches a notification stored as `/chat`. */
export function normalizeNotificationRoute(route: string): string {
  const path = route.startsWith('/') ? route : `/${route}`;
  const queryIndex = path.indexOf('?');
  const pathOnly = queryIndex === -1 ? path : path.slice(0, queryIndex);
  const query = queryIndex === -1 ? '' : path.slice(queryIndex);
  const parts = pathOnly.split('/').filter(Boolean);

  if (
    parts.length >= 2 &&
    !NOTIFICATION_ROUTE_PREFIXES.has(parts[0].toLowerCase()) &&
    NOTIFICATION_ROUTE_PREFIXES.has(parts[1].toLowerCase())
  ) {
    return `/${parts.slice(1).join('/')}${query}`;
  }

  return path;
}

/** True when the stored notification route is a case-insensitive prefix of the current path. */
export function notificationMatchesRoute(notificationRoute: string | null | undefined, currentPath: string): boolean {
  if (!notificationRoute) return false;
  const stored = notificationRoute.toLowerCase();

  const candidates = [currentPath, normalizeNotificationRoute(currentPath)];
  return candidates.some((candidate) => candidate.toLowerCase().startsWith(stored));
}
